import _axios from "axios";
import ReactSwal from "./AlertHelper";
import {
  getLocalStorageUser,
  removeLocalStorageUser,
} from "./LocalStorageHelper";
import { Translation } from "react-i18next";

function getToken() {
  try {
    const userInfo = getLocalStorageUser();
    console.debug("getToken: userInfo: ", userInfo);
    const user = JSON.parse(userInfo);
    console.debug("getToken: user: ", user);
    return user.jwt;
  } catch (error) {
    return "";
  }
}

function fireAlert(options) {
  ReactSwal.fire({
    title: <Translation>{(t) => <>{t("error.title")}</>}</Translation>,
    ...options,
  });
}

function shouldSuppressAlert(config, instanceDefault) {
  return config?.suppressAlert ?? instanceDefault;
}

function createAxios({ suppressAlert: instanceSuppressAlert = false } = {}) {
  const instance = _axios.create({
    baseURL: process.env.REACT_APP_API_SERVER,
    timeout: 2 * 60 * 100,
  });

  instance.interceptors.request.use((config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  instance.interceptors.response.use(
    function (response) {
      const suppressAlert = shouldSuppressAlert(
        response.config,
        instanceSuppressAlert
      );

      if (!response.data.success) {
        if (!suppressAlert) {
          fireAlert({
            html: response.data.message || "Unknown error",
          });
        }
        return Promise.reject(response.data.message || "Unknown error");
      }
      return response;
    },
    function (error) {
      const suppressAlert = shouldSuppressAlert(
        error.config,
        instanceSuppressAlert
      );
      const statusCode = error.response?.status;

      if (statusCode == 404) {
        if (!suppressAlert) {
          fireAlert({ html: "404 Not Found" });
        }
        return Promise.reject(error);
      }

      if (statusCode == 401) {
        // no permission or token expired
        removeLocalStorageUser();
        if (!suppressAlert) {
          fireAlert({
            html: error.response.data.error || "Expired",
            allowOutsideClick: false,
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              window.location.href = "/login";
            }
          });
        }
        return Promise.reject(error);
      }

      if (!suppressAlert) {
        fireAlert({
          html: error.response?.data?.error || error.message,
        });
      }

      return Promise.reject(error);
    }
  );

  return instance;
}

const AxiosHelper = {
  axios: createAxios,
};

export default createAxios();
export { AxiosHelper };
